import { rusPhoneCode } from '../../constants/constants';
export const validatePhone = ({ value, required }) => {
    if (required && !value) {
        return {
            message: 'Введите номер телефона',
            type: 'lostfocus',
        };
    }
    if (value === rusPhoneCode) {
        return null;
    }
    const patternPhone = /^\+7\d{10}$/;
    if (value && !patternPhone.test(value)) {
        return {
            message: 'Проверьте правильность введенного номера телефона',
            type: 'lostfocus',
        };
    }
    return null;
};
export const validatePhoneWithMatch = ({ phoneMatchValidationInfo, ...rest }) => validatePhone(rest) || phoneMatchValidationInfo;
